// Contents of this file was produced with a help of a code generation tool and
// subsequently reviewed and edited by a human.
//
// While some of the code was created by an AI assisted service, manual adjustments
// have been made to ensure correctness, readability, functionality and compliance
// to Avalara's coding standards and guidelines.
// Any future modifications should be approached with caution to avoid
// overwriting the manual changes.
//
//
// This source code is owned by Avalara Inc. Unauthorized copying of this file,
// via any medium, is strictly prohibited. Proprietary and confidential.
//
// For more information, refer to the documentation or contact the development team.

export const PRODUCT_ID_RBO_SUBSCRIPTION = 1;
export const PRODUCT_ID_MLT_PRO_SUBSCRIPTION = 5;
export const PRODUCT_ID_REGISTRATION_ONLY = 8;

export const PARTNER_USER_TYPE_RBO = 1;
export const PARTNER_USER_TYPE_MLT_PRO = 2;

// Which subscription product a partner's customers are sold for full compliance.
// Partner user-type ids are their own scale (1 RBO, 2 MLT Pro) and must not be
// confused with user-type ids or product ids. Flows with no partner user type --
// direct and sourceId -- fall through to MLT Pro, which is today's behaviour.
export const getSubscriptionProductId = (partnerUserTypeId?: number): number =>
  partnerUserTypeId === PARTNER_USER_TYPE_RBO
    ? PRODUCT_ID_RBO_SUBSCRIPTION
    : PRODUCT_ID_MLT_PRO_SUBSCRIPTION;
export const PRODUCT_TYPE_MLT_PRO = 3;

export const LINE_ITEM_TYPE_SETUP_FEE = 1;
export const LINE_ITEM_TYPE_SUBSCRIPTION_FEE = 2;

export const DIRECT_PARTNER_NAME = 'Direct';

export const COUNTRY_ID_USA = 1;

export const MAX_PROPERTY_COUNT = 120;

export const DEFAULT_LOGO = `${process.env.PUBLIC_URL}/assets/images/default-logo.png`;

export const DEFAULT_VIDEO_URL = 'https://www.youtube.com/watch?v=zk2JyaR1f40';
